var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedActiveIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.314 3.281c-0.353-0.354-0.926-0.354-1.279-1e-3l-10.851 10.822-3.916-4.252c-0.338-0.367-0.91-0.391-1.278-0.053-0.367 0.339-0.391 0.911-0.052 1.278l4.552 4.945c0.167 0.181 0.4 0.286 0.647 0.291h0.019c0.239 0 0.469-0.094 0.638-0.263l11.518-11.488c0.354-0.352 0.355-0.925 2e-3 -1.279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.096 11.096c-0.5 0-0.905 0.404-0.905 0.904 0 5.62-4.571 10.191-10.191 10.191-5.619 0-10.191-4.571-10.191-10.191 0-5.619 4.572-10.191 10.191-10.191 0.5 0 0.905-0.405 0.905-0.904 0-0.5-0.405-0.905-0.905-0.905-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12c0-0.5-0.405-0.904-0.904-0.904z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedActiveIc);
export default __webpack_public_path__ + "static/media/checked-active-ic.a418a185ae72690675b0fdd55a04b550.svg";
export { ForwardRef as ReactComponent };